const ReservedValue = {
    SPACE: 'SPACE',
    BACKSPACE: 'BACKSPACE',
    SPECIAL_CHAR: '#+?@',
    DELETE_ALL: '全削除',
    SWITCH_LANGUAGE_SET: 'カナ',
} as const;

type TReservedValue = typeof ReservedValue[keyof typeof ReservedValue];

export {ReservedValue as default, type TReservedValue};
